// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__24pIz","modalForm":"UpgradeEpcsModal_modalForm__1vrNS","modalFooter":"UpgradeEpcsModal_modalFooter__1vUdh"};